module.exports = __webpack_public_path__ + "img/Dantam Makeover 28.dd022931.jpg";